/**
 * 系统管控相关页 PermissionA5 子树。
 * permissionList：权限管理页及其操作位。
 */
const systemControl = {
  permissionList: {
    /** 页头「新建顶级权限」 */
    createTop: {
      buttonCodes: ['system:rbac:control']
    },
    edit: {
      // 后端若误发 rabc:control（a/b 顺序），与 system:rbac:control 不同字符串，需同时兼容
      buttonCodes: ['system:rbac:control']
    },
    assignRoles: {
      buttonCodes: ['system:rbac:assign']
    },
    delete: {
      buttonCodes: ['system:rbac:control']
    },
    /** 详情区「添加子权限」：按钮码 + dataRes 含 true 表示深度未达上限 */
    addChild: {
      buttonCodes: ['system:rbac:control'],
      dataRes: [true]
    }
  },
  roleList: {
    /** 页头「新建角色」 */
    create: {
      buttonCodes: ['system:role:control']
    },
    /** 表格行「修改」 */
    edit: {
      buttonCodes: ['system:role:control']
    },
    /** 表格行「分配权限」 */
    assignPermission: {
      buttonCodes: ['system:role:assign']
    },
    /** 表格行「添加成员」：为员工追加本角色 */
    addMember: {
      buttonCodes: ['system:role:assign']
    },
    /** 表格行「删除」 */
    delete: {
      buttonCodes: ['system:role:control']
    }
  }
}

export default systemControl
